/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_CSME = gql`
  query GetApplication($applicationNo: String!) {
    getApplication(applicationNo: $applicationNo) {
      createdAt
      updatedAt
      appliedOn
      applicant
      applicantInfo {
        vuid
        userId
        email
        employmentOccupation
        firstName
        middleName
        lastName
        employed
        maidenName
        middleName
        typeOfIdentification
        trn
        addressOfEmployer {
          addressLine1
          city
          parish
          country
        }
        NIS
        email
        fullName
        image
        accountStatus
        bannerImg
        address {
          addressLine1
          addressLine2

          city

          zipcode
          country
          parish
        }
        occupation
        bio
        primaryContactNo
        nationality

        createdAt
        alias
        childrenOrDependent
        gender
        maritalStatus
        otherNationality
        countryOfBirth
        placeOfBirth
        qualification {
          institute
          from
          to
          degree
          description
          address {
            addressLine1
            addressLine2

            city

            parish
            zipcode
            country
          }
          dateReceived
          degreeIfOther
        }
        skills
        trn
        dateOfBirth
        declaration {
          selected
          value
        }
        permissionPeriod {
          from
          to
        }
        natureOfOffence
        dependentInfo {
          dependentType
          name
          passportNumber
          relationship
          age
          documents {
            expiry
            fileType
            name
            src
            type
          }
          gender
          nationality
        }
        destinationCarribbeanState
        natureOfBusiness
        natureOfProfessionalActivity
        purposeOfRelocation
        isDependentExist
        dateOfEntry
        name
        nameChangeDocType
        notfinanciallyCapableReason
        portOfEntry
        employmentStatus
        highestQualification
        employmentAddress {
          addressLine1
          addressLine2

          city

          parish
          zipcode
          country
        }
        nameOfEmployer
        isNameChange
        passportNumber
      }
      applicationNo
      appliedBy
      documents {
        name
        type
        src
        fileType
        expiry
      }
      employerInfo {
        name
        natureOfBusiness
        email
        primaryContactNo
      }
      status
      type
      dependentInfo {
        dependentType
        name
        relationship
        passportNumber
        age
        gender
        nationality
        documents {
          name
          type
          src
          fileType
          expiry
        }
      }
      studentEducationDetail {
        educationType
        degreeOrCertificate
        instituteName
        instituteAddress {
          addressLine1
          addressLine2

          city

          parish
          zipcode
          country
        }
        primaryContactNo
        email
      }
      certificateInfo {
        credentialNo
        issuingAutority
        dateOfApplication
        issuanceDate
      }
    }
  }
`;
